import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updatePartners } from '../../api/partner.ts';
import type { UpdatePartnerRequest } from '../../api/requests/partner-request.ts';

export default function useCreatePartner(): UseMutationResult<
  string,
  Error,
  UpdatePartnerRequest
> {
  return useMutation({
    mutationFn: updatePartners,
  });
}
